import React, { useEffect, useState } from "react";
import styles from './scss/forgotPassword.module.scss';
//import loaderblue from '../styles/images/loaderblue.svg';
//import { URInput } from "../../shared/widgets/input";
import { URButton } from "../../shared/widgets/button";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { LoginService } from "../../base/loginService";
type ForgetPasswordProps = {
  updateState:(state:string, email?:string)=>void;
  email:string;
}
const ForgotPassword = ({updateState,email}:ForgetPasswordProps) => {
  const { register, handleSubmit,setError,clearErrors, formState: { errors },getValues,setValue } = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [Email, setEmail] = useState<string>('');
 
  useEffect(()=>{
    setValue('Email', email);
    setEmail(email);  
  },[]);
  const onSubmit = async(data:any) => {
    setLoading(true);
    if(data.Email){
      const finalObj = {
        called_by: "APP",
        email: data.Email,
        log_id: 0,new_pwd: "",type: 1
      };
      LoginService.forgotPassword(finalObj).then((value:any)=>{
        if(value?.statusCode===200){
          setLoading(false);
          updateState('reset',data.Email);
        }
        else if(value?.statusCode === 422 ){
          setLoading(false);
          updateState('forgot');
          setError("Email", {
            type: "manual",
            message: "There is no account for the email you entered."
          });  
        }     
      });
    }
  };
  const clearEmail = () =>{
    setValue('Email', "", { shouldDirty: true });
    clearErrors();
    setEmail("");
  };
  const changeEmail =(e:any)=>{
    setEmail(e.target.value)
    clearErrors();
  }
  const forgotPass =() =>{
    updateState("login",'');
    clearEmail();
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h5 className={styles.loginText}>Forgot Password?</h5>
        <p className={styles.forgotContent}>
      Enter your email address and we’ll send you a <br/>link to reset your password
        </p>
        <div className={styles.forgetPage}>
          <div className={styles.formLabel}>
            <label className={styles.inputLabel}>Email</label>
            <div className={`${styles.mailBox} ${errors.Email?'error':''}`}>
              <input className="mailBox" type="text" id="email" 
                 autoFocus={true}
               placeholder="Enter your email address"
                {...register("Email", {required: "Required data missing", pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: "Please enter a valid email address"
                }})}
              onChange={changeEmail}
              /> 
              {(getValues('Email')||Email)  && <span className={`icon_closefill 
              ${styles.showClear}`} onClick={clearEmail}></span>}
            </div>
           
            {errors.Email && <p className={styles.errorText}>{errors.Email.message}</p>}
          </div>

          <URButton className={`resetLink ${errors.Email
            ?'disabled':''}`}
          name={loading?"":"Send Password Recovery Link"}
          type={'primary'} htmlType="submit" />
        </div>
        <Link to=""  className={styles.backLink}>
          <span className="icon_outlineleftarrow"></span>
          <span className={styles.backText} onClick={forgotPass}>Back to login</span></Link>
      </form>
    </>
  );
};

export default ForgotPassword;